import React from 'react'


export default function RedCrossBanner() {
    return (
        <>
            <div class="container">
                <div class="icrspart">
                    <img src="../img/redcrossimage.jpg" alt="icrs image" class=".img-responsive" width={"100%"} />
                </div>
            </div>
        </>

    )
}
